import { memo, useId } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { ROLE_KIND_META } from '../../constants/copy';
import RoleCard from './RoleCard';

/**
 * One titled group (System Roles / Custom Roles); renders nothing when it has no roles.
 *
 * @param {object} props
 * @param {'system'|'custom'} props.kind
 * @param {object[]} props.roles
 * @param {(roleId: string) => void} props.onOpen
 */
const RoleGroup = ({ kind, roles, onOpen }) => {
  const { t } = useTranslation('people-access');
  const headingId = useId();
  if (!roles.length) return null;

  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-3">
      <div className="flex items-baseline gap-1.5 text-xs font-semibold uppercase tracking-wide text-content-muted">
        <h2 id={headingId}>{t(ROLE_KIND_META[kind].headingKey)}</h2>
        <span aria-hidden>{`· ${roles.length}`}</span>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 min-[1700px]:grid-cols-6">
        {roles.map((role) => (
          <RoleCard key={role.id} role={role} onOpen={onOpen} />
        ))}
      </div>
    </section>
  );
};


export default memo(RoleGroup);
